import Layout from '@/layout'

export default [
	{
		order: 5,
		path: '/manufacturer-organize',
		component: Layout,
		meta: {
			title: '厂商运维组织管理',
			subtitle: '运维',
			icon: 'icon-zuzhi',
		},
		redirect: '/manufacturer-organize/staff-manage',
		children: [
			{
				path: 'staff-manage',
				name: 'manStaffManage',
				meta: {
					title: '厂商员工管理',
					keepAlive: true,
					permissions: ['monitor:manufacturer:staffs'],
				},
				component: () => import('@/pages/manufacturer-organize-manage/staff-manage/index.vue'),
			},
			// {
			// 	path: 'mrole-manage',
			// 	name: 'mRoleManage',
			// 	meta: {
			// 		title: '角色管理',
			// 		keepAlive: true,
			// 		permissions: ['utos:tosm:role:manu'],
			// 	},
			// 	component: () => import('@/pages/manufacturer-organize-manage/role-manage/index.vue'),
			// },
		],
	},
]
